import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpensePaymentStarted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .844727,
		width: 15.9963,
		height: 16,
		rx: 7.99817,
		fill: "#FFB800"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.3975 7.2041L7.39027 10.1202C7.22981 10.2758 6.97299 10.2697 6.82012 10.1067L5.59863 8.80373",
		stroke: "white",
		strokeWidth: .599862,
		strokeLinecap: "square"
	})]
});
export default SvgExpensePaymentStarted;
